import { Component, OnInit, isDevMode } from '@angular/core';

@Component({
  selector: 'app-google-adsense',
  templateUrl: './google-adsense.component.html',
  styleUrls: ['./google-adsense.component.css'],
  standalone: false
})
export class GoogleAdsenseComponent implements OnInit {
  devMode: boolean;

  constructor() {
    this.devMode = isDevMode();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    (window['adsbygoogle'] = window['adsbygoogle'] || []).push({});
  }

}
